import { graphql } from '@revelio/data-access';

export const GAME_GET_RESULTS_STATS_V2 = graphql(`
  query GetGameResultsStatsV2(
    $entities: [CompositionV2Entity!]!
    $filters: CompositionV2Filters!
    $filtersSentV2: SentimentV2Filters
    $msa: [ID!]
    $role_k150: [ID!]
    $seniority: [ID!]
    $payReq: PayV2Req
  ) {
    rawComposition: composition_v2(
      req: { filters: $filters, entities: $entities }
    ) {
      entities {
        metadata {
          id
          short_name
          long_name
          type
        }
        metrics {
          headcount {
            id
            value
          }
          tenure {
            id
            value
          }
          salary {
            id
            value
          }
          growth_rate {
            id
            value
          }
          hiring_rate {
            id
            value
          }
          attrition_rate {
            id
            value
          }
        }
      }
    }

    posting(
      filters: {
        msa: $msa
        role_k150: $role_k150
        seniority: $seniority
        provider: [0]
        start_date: "2020-01-01"
        end_date: "2025-05-19"
      }
      dim1: geography
      dim2: date
    ) {
      metadata {
        id
        shortName
        longName
        __typename
      }
      category {
        metadata {
          id
          shortName
          longName
          __typename
        }
        metrics {
          time_to_fill
          active
          __typename
        }
        __typename
      }
      __typename
    }

    sentiment(filters: $filtersSentV2, dim1: geography) {
      result {
        scores {
          overall {
            count
            value
            month_id
            weight
            __typename
          }
        }
      }
    }

    pay_v2(req: $payReq) {
      entities {
        metadata {
          id
          short_name
          long_name
        }
        metrics {
          histogram {
            index
            total
          }
        }
      }
    }
  }
`);
